import script from "./DailyLimitModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyLimitModal.vue?vue&type=script&setup=true&lang=js"

import "./DailyLimitModal.vue?vue&type=style&index=0&id=c6cfd5be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6cfd5be"]])

export default __exports__